// ✅ TTL 지원 IndexedDB Cache Utility (Native IndexedDB)

// npm install idb-keyval
const DB_NAME = "app_cache_db";
const STORE_NAME = "app_cache_store";
const DB_VERSION = 1;

// IndexedDB 연결
function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => resolve(request.result);
  });
}

export default {
  /**
   * 저장 (TTL 지원)
   * @param {string} key
   * @param {any} value
   * @param {number|null} ttl   ms 단위 (예: 3600 * 1000 => 1시간)
   */
  async setItem(key, value, ttl = null) {
    const expiresAt = ttl ? Date.now() + ttl : null;

    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);

      store.put({ value, expiresAt }, key);

      tx.oncomplete = () => resolve(true);
      tx.onerror = () => reject(tx.error);
    });
  },

  /**
   * 가져오기 (만료된 경우 자동 삭제)
   */
  async getItem(key) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readonly");
      const store = tx.objectStore(STORE_NAME);

      const request = store.get(key);

      request.onsuccess = async () => {
        const data = request.result;

        if (!data) {
          resolve(null);
          return;
        }

        // TTL 체크
        if (data.expiresAt && data.expiresAt < Date.now()) {
          // 만료된 경우 자동 삭제
          await this.removeItem(key);
          resolve(null);
          return;
        }

        resolve(data.value);
      };

      request.onerror = () => reject(request.error);
    });
  },

  /**
   * 삭제
   */
  async removeItem(key) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);

      store.delete(key);

      tx.oncomplete = () => resolve(true);
      tx.onerror = () => reject(tx.error);
    });
  },

  /**
   * 전체 캐시 삭제
   */
  async clear() {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);

      store.clear();

      tx.oncomplete = () => resolve(true);
      tx.onerror = () => reject(tx.error);
    });
  }
};
